var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 212836487"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    opacity: 0.26,
    cx: 22.666,
    cy: 22,
    r: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.0466 15.7389C25.2692 15.7389 27.4009 16.6218 28.9725 18.1935C30.5442 19.7652 31.4271 21.8968 31.4271 24.1194C31.4271 26.3421 30.5442 28.4737 28.9725 30.0454C27.4009 31.6171 25.2692 32.5 23.0466 32.5C20.8239 32.5 18.6923 31.6171 17.1206 30.0454C15.549 28.4737 14.666 26.3421 14.666 24.1194C14.666 21.8968 15.549 19.7652 17.1206 18.1935C18.6923 16.6218 20.8239 15.7389 23.0466 15.7389ZM23.0466 17.834C21.3796 17.834 19.7809 18.4962 18.6021 19.675C17.4234 20.8537 16.7612 22.4525 16.7612 24.1194C16.7612 25.7864 17.4234 27.3852 18.6021 28.5639C19.7809 29.7427 21.3796 30.4049 23.0466 30.4049C24.7136 30.4049 26.3123 29.7427 27.491 28.5639C28.6698 27.3852 29.332 25.7864 29.332 24.1194C29.332 22.4525 28.6698 20.8537 27.491 19.675C26.3123 18.4962 24.7136 17.834 23.0466 17.834ZM23.0466 19.4054L24.4325 22.2129L27.5302 22.6633L25.2884 24.8475L25.8174 27.9336L23.0466 26.4765L20.2757 27.9326L20.8048 24.8475L18.563 22.6623L21.6606 22.2118L23.0466 19.4054ZM29.332 10.501V13.6438L27.9041 14.8359C26.7193 14.2142 25.4257 13.8269 24.0941 13.6951V10.501H29.332ZM21.999 10.5V13.6951C20.6679 13.8267 19.3747 14.2137 18.19 14.8348L16.7612 13.6438V10.501L21.999 10.5Z",
    fill: "#AE8BE3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.12aff4397e5437c311f3da5fa14fbc3e.svg";
export { ForwardRef as ReactComponent };